import { CalendarMonth } from "@mui/icons-material";
import { DesktopDatePicker } from "@mui/x-date-pickers";

import { inputStyles } from "../../../../cm/Dashboard/FullPages/constant";
import FormField from "../../../../global/FormComponents/field/FormField";

const DueDateField = ({ dateTimeVal, defaultDate, setDateTimeValue }) => (
  <FormField label="Due Date">
    <DesktopDatePicker
      value={!dateTimeVal ? defaultDate : dateTimeVal}
      className="mx-auto flex w-full text-black"
      onChange={(newValue) => setDateTimeValue(newValue)}
      components={{
        OpenPickerIcon: CalendarMonth,
      }}
      slotProps={{
        inputAdornment: {
          position: "start",
        },
      }}
      sx={{
        ...inputStyles,
        "& input": {
          marginLeft: "-8px",
        },
      }}
    />
  </FormField>
);

export default DueDateField;
